
// Create the script tag, set the appropriate attributes
var script = document.createElement('script');
script.src = 'https://maps.googleapis.com/maps/api/js?key=AIzaSyBRRh1-yvIMmPWALZhLiRBHJnIqGxfKi7M&callback=initMap';
script.async = true;



// Append the 'script' element to 'head'
document.head.appendChild(script);



// Attach your callback function to the `window` object
    window.initMap = function() {

      //const uluru = { lat: -25.344, lng: 131.031 };
      var pins = [];
      var pinTargets = [];
      var bounds = new google.maps.LatLngBounds();

      $('.list-project').each(function() {

        if ($(this).data('lat')) {

          pins.push({lat: $(this).data('lat'), lng: $(this).data('lng')})
          pinTargets.push({id: $(this).find('.project-panel-trigger-title').data('id'), prev: $(this).prev().find('.project-panel-trigger-title').data('id'), next: $(this).next().find('.project-panel-trigger-title').data('id')});

        }

      });

      const map = new google.maps.Map($('#map')[0], {

        center: pins[0],
        zoom: 5,
        disableDefaultUI: true,
        styles: [{"featureType":"administrative","elementType":"all","stylers":[{"saturation":"-100"}]},{"featureType":"administrative.province","elementType":"all","stylers":[{"visibility":"off"}]},{"featureType":"landscape","elementType":"all","stylers":[{"saturation":-100},{"lightness":65},{"visibility":"on"}]},{"featureType":"poi","elementType":"all","stylers":[{"saturation":-100},{"lightness":"50"},{"visibility":"simplified"}]},{"featureType":"road","elementType":"all","stylers":[{"saturation":"-100"}]},{"featureType":"road.highway","elementType":"all","stylers":[{"visibility":"simplified"}]},{"featureType":"road.arterial","elementType":"all","stylers":[{"lightness":"30"}]},{"featureType":"road.local","elementType":"all","stylers":[{"lightness":"40"}]},{"featureType":"transit","elementType":"all","stylers":[{"saturation":-100},{"visibility":"simplified"}]},{"featureType":"water","elementType":"geometry","stylers":[{"hue":"#ffff00"},{"lightness":-25},{"saturation":-97}]},{"featureType":"water","elementType":"labels","stylers":[{"lightness":-25},{"saturation":-100}]}]

      });


      for (var i = 0; i < pins.length; i++) {

        console.log(wp.templateUrl);

        const icon = {
            url: wp.templateUrl + '/public/img/pin-nr.png', // url
            scaledSize: new google.maps.Size(56, 56), // scaled size
            origin: new google.maps.Point(0,0), // origin
            anchor: new google.maps.Point(28, 28) // anchor
        };

        const icon2 = {
            url: wp.templateUrl + '/public/img/pin-2-nr.png', // url
            scaledSize: new google.maps.Size(56, 56), // scaled size
            origin: new google.maps.Point(0,0), // origin
            anchor: new google.maps.Point(28, 28) // anchor
        };

        bounds.extend(pins[i]);

        console.log(pins[i]);

        const marker = new google.maps.Marker({
          position: pins[i],
          map: map,
          icon: icon,
        });

        google.maps.event.addListener(marker, 'click', (function(marker, i) {
          return function() {
            console.log('test' + i);
            console.log(pinTargets[i].id);
            $('.project-panel').fadeIn(function() {

              $('.project-panel').addClass('open');
              buildAjaxPost(pinTargets[i].id, pinTargets[i].next, pinTargets[i].prev);

            });
          }
        })(marker, i));

        google.maps.event.addListener(marker, 'mouseover', (function(marker, i) {
          return function() {
            
            console.log('test');
            marker.setIcon(icon2);

          }
        })(marker, i));

        google.maps.event.addListener(marker, 'mouseout', (function(marker, i) {
          return function() {
            
            console.log('test');
            marker.setIcon(icon);

          }
        })(marker, i));

      }


      google.maps.event.addListenerOnce(map, 'bounds_changed', function(event) {
        this.setZoom(map.getZoom()-1);

        if (this.getZoom() > 15) {
          this.setZoom(15);
        }
      });
      map.fitBounds(bounds);
      map.setCenter(bounds.getCenter());

    };

(function($) {
  $(document).ready(function($) {

    console.log(wp_language_code);

  	$('.mob-menu-trigger').on('click', function() {

  		$('.menu-modal').fadeToggle();

  	})

    $('#hp-video-trigger').on('click', function() {

      $('#hp-video-modal').fadeIn(function() {

        $('#hp-video-modal').find('video')[0].play();

      });

    });

  	$('.project-panel-trigger').on('click', function() {

  		if ($('.project-panel').hasClass('open')) {

  			$('.project-panel').removeClass('open');

  			setTimeout(function() {

  				$('.project-panel').fadeOut();
          $('.project-panel__wrap').removeClass('open');

  			}, 500);

  		} else {

  			$('.project-panel').fadeIn(function() {

  				$('.project-panel').addClass('open');

  			});

  		}

      if ($(this).data('id')) {

        var postID = $(this).data('id');
        var nextID = $(this).next().data('id');
        var prevID = $(this).prev().data('id');

        if ($(this).hasClass('project-panel-trigger-title')) {

          console.log($(this).parents('.list-project'));
          nextID = $(this).parents('.list-project').next().find('.project-panel-trigger-title').data('id');
          prevID = $(this).parents('.list-project').prev().find('.project-panel-trigger-title').data('id');

        }

        buildAjaxPost(postID, nextID, prevID);

      }

  	});

    function buildAjaxPost(postID, nextID, prevID) {

      var post;

      clearAjaxPost();

      $.ajax({
        type: 'POST',
        url: ajaxurl,
        dataType: "json", // add data type
        data: {
          action : 'get_ajax_post',
          data : {
            'postID': postID,
            'nextID': nextID,
            'prevID': prevID,
          },
        },
        success: function( response ) {
            
            var nextText = $('#project-next-text').text();
            var prevText = $('#project-prev-text').text();

            post = response;
            
            $('#panel-category').text(post['category']);
            $('#panel-title').text(post['post_title']);

            $('#panel-slideshow').append('<div class="slide"><div class="img-wrap"><img src="' + post['featuredImage']['retina'] + '"></div></div>')
            $(post['slideshowImages']).each(function() {
              $('#panel-slideshow').append('<div class="slide"><div class="img-wrap"><img src="' + $(this)[0]['retina'] + '"></div></div>')
            });
            panelSlideshowInit();
            
            $('#image-modal-slideshow').append('<div class="slide"><div class="img-wrap"><img src="' + post['largeFeaturedImage']['retina'] + '"></div></div>');
            $(post['largeSlideshowImages']).each(function() {
              $('#image-modal-slideshow').append('<div class="slide"><div class="img-wrap"><img src="' + $(this)[0]['retina'] + '"></div></div>');
            });
            panelLargeSlideshowInit();

            $('#panel-map').attr('href', post['mapLink']);

            if (post['video'].length) {

              $('#panel-video').show().siblings().removeClass('only-child');

            } else {

              $('#panel-video').hide().siblings().addClass('only-child');

            }

            $('#panel-video-target').attr('src', post['video']);
            $('#panel-intro').html(post['post_content']);
            $(post['details']).each(function() {
              $('#panel-stats').prepend('<div class="stat"><h4>' + $(this)[0]['title'] + '</h4><span>' + $(this)[0]['text'] + '</span></div>')
            });
            $('#panel-location').text(post['location']);
            $('#panel-strategy').text(post['investmentStrategy']);
            $('#panel-strategy-title').toggle(!!post['investmentStrategy']);

            $('.project-panel__wrap').addClass('open');

            if (post['prevPostID']) {

              var prevButton = '';
              prevButton += "<button class='prev' data-id='" + post['prevPostID'] + "'>";
              prevButton += "<img class='' src='" + post['prevThumbImg']['retina'] + "'>";
              prevButton += "<h5><span>" + prevText + "</span>" + post['prevPostTitle'] + "</h5>";
              prevButton += "</button>";  
              $('.project-panel__footer').prepend(prevButton);  

            }
            if (post['nextPostID']){

              var nextButton = '';
              nextButton += "<button class='next' data-id='" + post['nextPostID'] + "'>";
              nextButton += "<h5><span>" + nextText + "</span>" + post['nextPostTitle'] + "</h5>";
              nextButton += "<img class='' src='" + post['nextThumbImg']['retina'] + "'>";
              nextButton += "</button>";  
              $('.project-panel__footer').append(nextButton);  

            }
        }
      });

    }

    function clearAjaxPost() {

      $('#panel-category').text('');
      $('#panel-title').text('');
      $('.panel-slideshow-inner.slick-initialized').slick('unslick');
      $('#panel-slideshow').html('');
      $('#image-modal-slideshow.slick-initialized').slick('unslick');
      $('#image-modal-slideshow').html('');
      $('#panel-map').attr('href', '');
      $('#panel-intro').html('');
      $('#panel-stats').children('.stat:not(#panel-location-stat)').remove();
      $('#panel-location').text('');
      $('#panel-strategy').text('');
      $('#panel-strategy-title').hide();
      $('#panel-video-target').attr('src', '');
      $('#panel-slideshow-current').text('1');
      $('.project-panel__footer').html('');

    }

    function panelSlideshowInit() {

      var total = $('.panel-slideshow-inner').find('img').length;

      $('.panel-slideshow-inner').on('init', function(event, slick) {

        $('#panel-slideshow-total').text(total);

      });

      $('.panel-slideshow-inner').on('beforeChange', function(event, slick, currentSlide, nextSlide) {

        $('#panel-slideshow-current').text(nextSlide + 1);

      });

      $('.panel-slideshow-inner').slick({

        fade: true,
        prevArrow: $('#panel-slideshow-prev'),
        nextArrow: $('#panel-slideshow-next'),
        asNavFor: '#image-modal-slideshow',
        responsive: [

          {
            breakpoint: 800,
            settings: {
              fade: false,
              //variableWidth: true,
              slidesToShow: 1.1,
              infinite: false,
            }
          },

        ]

      });

    }

    function panelLargeSlideshowInit() {

      $('#image-modal-slideshow').slick({

        slidesToShow: 1,
        slidesToScroll: 1,
        fade: true,
        asNavFor: '.panel-slideshow-inner',
        prevArrow: $('#image-modal-prev'),
        nextArrow: $('#image-modal-next'),

      })

    }

    $('.panel-slideshow-expand').on('click', function() {

      $('#image-modal').fadeIn();

    });

    $('#panel-video').on('click', function() {

      $('#panel-video-modal').fadeIn();

    });


    $('.team-member-card').on('click', function() {

      var postId = $(this).data('id');

      console.log(postId);
      $('.team-modal').fadeIn();
      buildTeamPost(postId);

    });

    function buildTeamPost(postID) {

      $.ajax({
        type: 'POST',
        url: ajaxurl,
        dataType: "json", // add data type
        data: {
          action : 'get_team_post',
          data : {
            'postID': postID
          },
        },
        success: function( response ) {
          $('.team-modal__single').html(response).fadeIn();
        },
        error: function( response ) {
          console.log(response);
        }
      });

    }

    $('.team-modal__shade, .team-modal__close').on('click', function() {

      $('.team-modal').fadeOut();
      $('.team-modal__single').hide();

    });

    $(document).on('click', '.project-panel__footer button', function() {

      var postID = $(this).data('id');
      var nextID = $('#project-' + postID).next().data('id');
      var prevID = $('#project-' + postID).prev().data('id');

      if ($('#project-' + postID).hasClass('project-panel-trigger-title')) {

        nextID = $('#project-' + postID).parents('.list-project').next().find('.project-panel-trigger-title').data('id');
        prevID = $('#project-' + postID).parents('.list-project').prev().find('.project-panel-trigger-title').data('id');

      }

      $('.project-panel__wrap').removeClass('open');

      setTimeout(function() {

        buildAjaxPost(postID, nextID, prevID);

      }, 300);

    });


    $(".project-panel__shade").on('click', function() {

      $('.project-panel').removeClass('open');

      setTimeout(function() {

        $('.project-panel').fadeOut();
        $('.project-panel__wrap').removeClass('open');

      }, 500);

    });

  	$('.video-modal__close').on('click', function() {

      var par = $(this).parents('.video-modal');
  		par.find('video')[0].pause();
  		par.fadeOut();

  	});

    $('.image-modal__close').on('click', function() {

      $('.image-modal').fadeOut();

    });


  	if ($('.list-project').length) {

  		var allProjects = $('.list-project').detach().appendTo('.projects-page__list');
  		console.log(allProjects);

  		$('.projects-page-filter').on('click', function() {

	  		var filter = $(this).data('filter') || false;
	  		var filteredPosts;

	  		allProjects.appendTo('.projects-page__list');

	  		if (filter) {

	  			filteredPosts = $('.project-' + filter).detach();
	  			$('.list-project').detach();
	  			filteredPosts.appendTo('.projects-page__list');

	  		}

	  		$(this).addClass('active').siblings().removeClass('active');

        initMap();

	  	});

  	}
  	

    if ($('.hp-hero-switcher:not(.no-switch)').length) {

    	var counter = 0
    	var words = $('.hp-hero-switcher').data('words');

    	setInterval(function() {

    		$('#hp-hero-switcher-target').fadeOut('slow', function(){

    			$(this).text(words[counter]);
    			counter++;

    		}).fadeIn('slow');

    		if (counter >= words.length) { counter = 0 }

    	}, 4000);

    }

    if ($('.hp-main__projects__main').length) {

      // debounce from underscore.js
      function debounce(func, wait, immediate) {
        var timeout;
        return function() {
          var context = this, args = arguments;
          var later = function() {
            timeout = null;
            if (!immediate) func.apply(context, args);
          };
          var callNow = immediate && !timeout;
          clearTimeout(timeout);
          timeout = setTimeout(later, wait);
          if (callNow) func.apply(context, args);
        };
      };

      // use x and y mousewheel event data to navigate flickity
      function slick_handle_wheel_event(e, slick_instance, slick_is_animating) {
        // do not trigger a slide change if another is being animated
        if (!slick_is_animating) {
          // pick the larger of the two delta magnitudes (x or y) to determine nav direction
          var direction =
            Math.abs(e.deltaX) > Math.abs(e.deltaY) ? e.deltaX : e.deltaY;

          console.log("wheel scroll ", e.deltaX, e.deltaY, direction);

          if (e.deltaY == -0) {

            if (direction > 0) {
              // next slide
              slick_instance.slick("slickNext");
            } else {
              // prev slide
              slick_instance.slick("slickPrev");
            }

          }
          
        }
      }

      // debounce the wheel event handling since trackpads can have a lot of inertia
      var slick_handle_wheel_event_debounced = debounce( 
        slick_handle_wheel_event
        , 50, true
      );

      // init slider 
      const slick_2 = $('.hp-main__projects__main');
      slick_2.slick({

        variableWidth: true,
        centerMode: false,
        infinite: false,
        //arrows: false,
        prevArrow: $('#hp-projects-prev'),
        nextArrow: $('#hp-projects-next'),
        responsive: [

          {
            breakpoint: 800,
            settings: {
              fade: false,
              variableWidth: false,
              slidesToShow: 1.1,
              infinite: false,
            }
          },

        ]

      });
      var slick_2_is_animating = false;

      slick_2.on("afterChange", function(index) {
        console.log("Slide after change " + index);
        slick_2_is_animating = false;
      });

      slick_2.on("beforeChange", function(index) {
        console.log("Slide before change " + index);
        slick_2_is_animating = true;
      });

      slick_2.on("wheel", function(e) {
        slick_handle_wheel_event_debounced(e.originalEvent, slick_2, slick_2_is_animating);  
      });

    }


    if ($('.list-project__slideshow').length) {

    	$('.list-project__slideshow').each(function() {

    		var $this = $(this);
    		var total = $(this).find('img').length;

    		$this.find('.inner').on('init', function(event, slick) {

    			$this.find('.list-project-total').text(total);

    		});

    		$this.find('.inner').on('beforeChange', function(event, slick, currentSlide, nextSlide) {

    			$this.find('.list-project-current').text(nextSlide + 1);

    		});

    		$this.find('.inner').slick({

	    		fade: true,
	    		prevArrow: $this.find('.list-project-prev'),
	    		nextArrow: $this.find('.list-project-next'),

	    	});

    	});

    }

    if ($('[data-bg]').length) {

    	var tar = $('[data-bg]').offset().top + ($('[data-bg]').outerHeight() / 2);
      var altTar = $('[data-bg-alt]').offset().top - window.viewport().height || false;
    	var scroll;

    	$(window).on('scroll', function() {

    		scroll = $(window).scrollTop();

        if (altTar) {

          if (scroll > tar && scroll < altTar) {

            $('body').addClass('alt-style');

          } else {

            $('body').removeClass('alt-style');

          }

        } else {

          if (scroll > tar) {

            $('body').addClass('alt-style');

          } else {

            $('body').removeClass('alt-style');

          }

        }

    	});

    }

    if ($('.hp-stat').length) {

    	$(window).on('scroll', function() {

    		$('.hp-stat:not(.done)').each(function() {

    			if ($(window).scrollTop() + window.viewport().height > $(this).offset().top + $(this).outerHeight()) {

    				var num = $(this).data('num')
    				var numCounter = 0;
    				var $this = $(this);
    				var numInterval = 20;

    				$this.addClass('done');
    				$this.counter = setInterval(function(){

    					if ($this.data('slow')) {

    						console.log('test!');
    						numInterval = 1;

    					}

    					numCounter = numCounter + numInterval;

    					if (numCounter >= num) {

    						clearInterval($this.counter);
    						$this.text(num);

    					} else {

    						$this.text(numCounter);

    					}

    				}, 75);

    			}

    		});

    	});

    }

    $('.team-load-cta').on('click', function() {

      $(this).slideUp();
      $('.about-page__team-members.closed').css('display', 'grid').hide().slideDown();

    });

  });
})(jQuery);
